// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"DP-z","carouselContainer":"EP-z"};